export const MenuIcon = () => (
  <svg
    width="31"
    height="15"
    viewBox="0 0 31 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="#5C646B">
      <line x1="0.64502" y1="0.765625" x2="30.645" y2="0.765625" />
      <line x1="0.64502" y1="7.5" x2="30.645" y2="7.5" />
      <line x1="0.64502" y1="14.2363" x2="30.645" y2="14.2363" />
    </g>
  </svg>
)
